import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

export default function HeroSection() {
  const { t } = useTranslation('common');

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToServices = () => {
    const element = document.getElementById('services');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/244d8657-f4f8-4a44-9ef2-fd42a27f93d2.png"
          alt="Hero Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <img
            src="https://static.readdy.ai/image/24aeac95850e55fcda9f6af40f64c6a6/5533c6b9721b42fabcee3c27bfcaba87.png"
            alt="Yamauchi Partners"
            className="h-16 w-auto object-contain mx-auto mb-8"
          />
          <h1 className="text-5xl md:text-7xl font-light text-white mb-4">
            {t('hero.title1')}
          </h1>
          <h1 className="text-6xl md:text-8xl font-bold text-white mb-8">
            {t('hero.title2')}
          </h1>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="mb-12"
        >
          <p className="text-lg md:text-xl text-white/90 mb-2">
            {t('hero.subtitle1')}
          </p>
          <p className="text-lg md:text-xl text-white/90">
            {t('hero.subtitle2')}
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-16"
        >
          <button
            onClick={scrollToContact}
            className="px-8 py-4 bg-gray-900 text-white rounded-full text-base font-medium hover:bg-gray-800 transition-all hover:scale-105 cursor-pointer whitespace-nowrap"
          >
            {t('hero.cta')}
          </button>
          <button
            onClick={scrollToServices}
            className="px-8 py-4 text-white text-base font-medium hover:text-white/80 transition-colors cursor-pointer whitespace-nowrap"
          >
            {t('hero.details')} →
          </button>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto"
        >
          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 transform hover:scale-105 transition-transform">
            <div className="w-full h-48 mb-4 rounded-xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/ab7837797ff99e0ff2067ecbf1f3da4e.jpg"
                alt="Business Consulting"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <h3 className="text-xl font-semibold text-white mb-2">
              {t('services.consulting.title')}
            </h3>
          </div>

          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 transform hover:scale-105 transition-transform md:translate-y-8">
            <div className="w-full h-48 mb-4 rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=beautiful%20tropical%20destination%20in%20Malaysia%20featuring%20pristine%20beaches%20turquoise%20waters%20palm%20trees%20and%20scenic%20coastal%20landscape%20with%20warm%20sunny%20weather%20and%20vibrant%20colors%20showcasing%20paradise%20travel%20destination&width=400&height=300&seq=service-card-002&orientation=landscape"
                alt="Travel Guide"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <h3 className="text-xl font-semibold text-white mb-2">
              {t('services.travel.title')}
            </h3>
          </div>

          <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 transform hover:scale-105 transition-transform">
            <div className="w-full h-48 mb-4 rounded-xl overflow-hidden">
              <img
                src="https://static.readdy.ai/image/24aeac95850e55fcda9f6af40f64c6a6/e8684a738dc40b7c898ab926959bd28f.jpeg"
                alt="School Support"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <h3 className="text-xl font-semibold text-white mb-2">
              {t('services.school.title')}
            </h3>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
